// Dates as a South African reads them, matching the rest of the cockpit rather
// than the ISO strings Postgres sends. Written here rather than pulled from
// utils/interviews so that neither file has to import the other: formatDate
// there takes a different shape and is used by ported components.
//
// South Africa is UTC+2 all year with no daylight saving, so parsing a bare date
// as UTC and reading it back in UTC is exact for a date-only value and cannot
// slip a day, which a local-time parse can.
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/** '2026-08-23' or a full timestamp -> '23 Aug 2026'. Empty in, empty out. */
export function readableDate(value: string | null | undefined): string {
  if (!value) return ''
  const iso = String(value).slice(0, 10)
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso)
  if (!m) return String(value)
  const month = MONTHS[Number(m[2]) - 1]
  if (!month) return String(value)
  return `${Number(m[3])} ${month} ${m[1]}`
}
